import React, { useRef, useState, useCallback, useEffect } from "react";
import { Table, Button, OverlayTrigger, Tooltip, Row, Col } from "react-bootstrap";
import { FaEye, FaUpload, FaDownload } from "react-icons/fa";
import AOS from 'aos';
import 'aos/dist/aos.css';
import axios from "axios";
import config from "../config/Config";
import { apiHeaderToken, apiHeaderTokenMultiPart } from "../helper/My_Helper";
import moment from "moment/moment";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Paper, Step, StepLabel, Stepper, Typography } from "@mui/material";
import { getCandidateById } from "../helper/Api_Helper";

const actionButtons = [
    { icon: <FaEye />, label: 'View', onClickKey: 'onView', color: '#1E88E5' },
    { icon: <FaDownload />, label: 'Download', onClickKey: 'onDownload', color: '#1E88E5' },
    { icon: <FaUpload />, label: 'Upload', onClickKey: 'onUpload', color: '#43A047' },
];

const DocumentTable = ({ documents, handlers, editMode }) => (

    <Table striped bordered hover responsive>
        <thead>
            <tr>
                <th>Document Name</th>
                <th>Uploaded By</th>
                <th>Added Date</th>
                <th>Actions</th>
            </tr>
        </thead>
        <tbody>
            {documents && documents.length ? (
                documents?.map(doc => (
                    <tr key={doc._id}>
                        <td>{doc?.doc_name}</td>
                        <td>{doc?.uploaded_file_data?.added_by_data?.name || doc?.send_file_data?.added_by_data?.name || "N/A"}</td>
                        <td>{moment(doc?.send_file_data?.add_date).format("DD/MM/YYYY")}</td>
                        <td>
                            {!editMode ? actionButtons?.filter((item => item?.label === 'View')).map(btn => (
                                <OverlayTrigger
                                    key={btn?.label}
                                    placement="top"
                                    overlay={
                                        <Tooltip
                                            style={{ backgroundColor: btn.color }}
                                            className="custom-tooltip"
                                        >
                                            {btn?.label}
                                        </Tooltip>
                                    }
                                >
                                    <Button
                                        variant="link"
                                        className="mx-1 p-0"
                                        style={{ color: btn.color }}
                                        onClick={() => handlers[btn.onClickKey](doc)}
                                    >
                                        {btn.icon}
                                    </Button>
                                </OverlayTrigger>
                            )) : actionButtons.map(btn => (
                                <OverlayTrigger
                                    key={btn?.label}
                                    placement="top"
                                    overlay={
                                        <Tooltip
                                            style={{ backgroundColor: btn.color }}
                                            className="custom-tooltip"
                                        >
                                            {btn?.label}
                                        </Tooltip>
                                    }
                                >
                                    <Button
                                        variant="link"
                                        className="mx-1 p-0"
                                        style={{ color: btn.color }}
                                        onClick={() => handlers[btn.onClickKey](doc)}
                                    >
                                        {btn.icon}
                                    </Button>
                                </OverlayTrigger>
                            ))}
                        </td>
                    </tr>
                ))
            ) : (
                <tr>
                    <td colSpan={4} className="text-center text-muted">
                        No documents available
                    </td>
                </tr>
            )}
        </tbody>
    </Table>
);

const VerifiedDocument = () => {
    // const [key, setKey] = useState('offerLetter');
    const [documents, setDocuments] = useState(null);

    const uploadInputRef = useRef(null);
    const [pendingUploadDoc, setPendingUploadDoc] = useState(null);

    const jsonData = sessionStorage.getItem('loginData');
    const dataObject = jsonData ? JSON.parse(jsonData) : null;
    const [candidateData, setCandidateData] = useState(null);

    const GetCandidateUploadsDocument = useCallback(async () => {
        try {

            const response = await axios.post(
                `${config.API_URL}getOnboardDocuments`,
                { candidate_id: dataObject?._id },
                apiHeaderToken()
            );

            if (response.status === 200) {
                setDocuments(response.data?.data);
            } else {
                setDocuments(null);
            }
        } catch (error) {
            console.error(error);
            setDocuments(null);
        }
    }, [dataObject?._id]);

    useEffect(() => {
        if (dataObject?._id) {
            (async () => {
                const response = await getCandidateById({ _id: dataObject?._id, scope_fields: [] });
                setCandidateData(response.data ?? {});
            })()
        }
    }, [dataObject?._id])

    const handleFilesSelected = async (files, doc) => {
        if (!files || !files.length) return;
        const formData = new FormData();
        Array.from(files).forEach((file, idx) => {
            formData.append(`attachments[${idx}][doc_name]`, file?.name);
            formData.append(`attachments[${idx}][file_name]`, file);
        });

        formData.append('onboard_doc_id', doc._id);
        formData.append('approval_note_id', doc?.approval_note_doc_id);
        formData.append('candidate_id', dataObject?._id);
        formData.append("add_by_name", "Candidate")
        formData.append("add_by_mobile", "")
        formData.append("add_by_designation", '')
        formData.append("add_by_email", '')

        // https://hrmsapis.dtsmis.in/v1/admin/uploadOnboardingDocuments

        try {
            let response = await axios.post(
                `${config.API_URL}uploadOnboardingDocuments`,
                formData,
                apiHeaderTokenMultiPart()
            );

            if (response.status === 200) {
                toast.success(response?.data?.message);
                GetCandidateUploadsDocument();
            } else {
                toast.error(response?.data?.message);
            }
        } catch (err) {
            console.error('Upload failed:', err);
            toast.error(err?.response?.data?.message || err?.message || "Something went wrong");
        }
    };

    const handlers = {
        onView: doc => {
            const fileUrl = doc?.uploaded_file_data?.file_name ? config.IMAGE_PATH + doc?.uploaded_file_data?.file_name : config.IMAGE_PATH + doc?.send_file_data?.file_name;
            window.open(fileUrl, '_blank', 'noopener,noreferrer');
        },
        onDownload: async doc => {
            const fileUrl = doc?.uploaded_file_data?.file_name ? config.IMAGE_PATH + doc?.uploaded_file_data?.file_name : config.IMAGE_PATH + doc?.send_file_data?.file_name;;
            const fileName = doc?.uploaded_file_data?.file_name ? config.IMAGE_PATH + doc?.uploaded_file_data?.file_name : config.IMAGE_PATH + doc?.send_file_data?.file_name || 'download';
            try {
                const response = await fetch(fileUrl, { mode: 'cors' });
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (err) {
                console.error('Download failed:', err);
                toast.error('Download failed.');
            }
        },
        onUpload: doc => {
            setPendingUploadDoc(doc);
            uploadInputRef.current?.click();
        }
    };

    useEffect(() => {
        AOS.init({ duration: 800, once: true });
        GetCandidateUploadsDocument();
    }, [GetCandidateUploadsDocument]);

    const steps = [
        {
            eventKey: 'offerLetter',
            title: 'Offer Letter',
            docs: documents?.onboarding_docs?.filter(item => item?.doc_category === 'Offer Letter') || [],
            editMode: documents?.onboarding_docs_stage === 'offerletter'
        },
        {
            eventKey: 'joiningKit',
            title: 'Joining Kit',
            docs: documents?.onboarding_docs?.filter(item => item?.doc_category === 'Joining Kit') || [],
            editMode: documents?.onboarding_docs_stage === 'joiningkit'
        },
        {
            eventKey: 'appointmentLetter',
            title: 'Appointment Letter',
            docs: documents?.onboarding_docs?.filter(item => item?.doc_category === 'Appointment Letter') || [],
            editMode: documents?.onboarding_docs_stage === 'appointmentletter'
        },
    ]?.filter(step => step?.docs.length > 0);

    const [activeStep, setActiveStep] = useState(0);
    const [previewMode, setPreviewMode] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);

    useEffect(() => {

        if (documents?.onboarding_docs_stage === 'offerletter') {
            setActiveStep(0);
        } else if (documents?.onboarding_docs_stage === 'joiningkit') {
            setActiveStep(1);
        } else if (documents?.onboarding_docs_stage === 'appointmentletter') {
            setActiveStep(2);
        } else if (documents?.onboarding_docs_stage === 'complete') {
            setPreviewMode(true);
        }
    }, [documents?.onboarding_docs_stage, steps.length])

    const updateOnboardingStage = async (stage) => {

        try {
            const response = await axios.post(
                `${config.API_URL}update_candidate_onboard_mail_steps`,
                { candidate_doc_id: dataObject?._id, applied_job_id: candidateData?.applied_jobs?.find((item) => item?.job_id === candidateData?.job_id)?._id, action: stage },
                apiHeaderToken()
            );

            if (response.status === 200) {
                toast.success(response.data.message);
                GetCandidateUploadsDocument();

                const lastStepKey = steps.length > 0 ? steps[steps.length - 1].eventKey.toLowerCase() : '';

                if (stage === lastStepKey) {
                    setPreviewMode(true);
                } else {
                    setActiveStep(step => Math.min(step + 1, steps.length - 1));
                }
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.message || error?.message || "Something went wrong");
        } finally {
            setOpenAlert(false);
        }
    }

    const handleNext = () => {
        setPreviewMode(false);
        const stageMap = steps.map(s => s.eventKey.toLowerCase()); // Only valid steps

        if (steps.length === 0) return; // No steps, do nothing

        if (documents?.onboarding_docs_stage === stageMap[activeStep]) {
            setOpenAlert(true)
        } else {
            if (activeStep < steps.length - 1) {
                setActiveStep(step => step + 1);
                setPreviewMode(true);
            }
        }
    };

    useEffect(() => {
        if (activeStep >= steps.length) {
            setActiveStep(steps.length > 0 ? steps.length - 1 : 0);
        }
    }, [activeStep, steps.length]);


    const handleBack = () => {
        // Go back one step
        setActiveStep(step => Math.max(step - 1, 0));

        // Enter preview mode so that the “Next” button becomes “Skip” and NO API call happens
        setPreviewMode(true);
    };



    return (
        <>


            <div className="maincontent">
                <div className="container animate__animated animate__fadeIn animate__slower">

                    <div className="contentwrap">
                        <div className="contentbox">
                            <div className="contenthdr">
                                <h4>Onboard Documents</h4>
                            </div>
                            <Row>
                                <Col>
                                    <Box sx={{ width: '100%' }}>
                                        <Stepper activeStep={activeStep} alternativeLabel>
                                            {steps.map((step, index) => (
                                                <Step key={index}>
                                                    <StepLabel>{step.title}</StepLabel>
                                                </Step>
                                            ))}
                                        </Stepper>

                                        <Paper elevation={3} sx={{ p: 3, mt: 2 }}>
                                            {steps.length > 0 && steps[activeStep] ? (
                                                <DocumentTable documents={steps[activeStep]?.docs} handlers={handlers} editMode={steps[activeStep]?.editMode} />
                                            ) : (
                                                <Typography>No documents available.</Typography>
                                            )}

                                            <Box mt={3} display="flex" justifyContent="space-between">
                                                <Button disabled={activeStep === 0} onClick={handleBack}>
                                                    Back
                                                </Button>
                                                <Button
                                                    // disabled={documents?.onboarding_docs_stage === 'complete'}
                                                    onClick={handleNext}
                                                    variant="contained"
                                                >
                                                    {previewMode ? 'Next' : 'Submit'}
                                                </Button>
                                            </Box>
                                        </Paper>
                                    </Box>

                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>

            </div>

            <ToastContainer
                position="top-right"
                autoClose={5000}
                theme="dark"
                limit={1}
            />


            {/* Hidden multiple-file input */}
            <input
                type="file"
                ref={uploadInputRef}
                style={{ display: 'none' }}
                onChange={e => {
                    handleFilesSelected(e.target.files, pendingUploadDoc);
                    e.target.value = null;
                }}
            />


            <Dialog
                open={openAlert}
                onClose={() => setOpenAlert(false)}
                aria-describedby="confirm-dialog-description"
                aria-labelledby="confirm-dialog-title"
            >
                <DialogTitle
                    id="confirm-dialog-title"
                    sx={{
                        color: theme => theme.palette.warning.main,
                        // if you also want a background:
                        // bgcolor: theme => theme.palette.warning.light,
                        // px: 3, py: 1  // optional padding
                    }}
                >
                    Alert
                </DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        Please verify that you have reviewed all documents for “{steps[activeStep]?.title}”.
                        <br /><br />
                        <strong>This action cannot be undone.</strong><br />
                        Are you sure you want to submit this step?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenAlert(false)} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={() => {
                        const stageMap = ['offerletter', 'joiningkit', 'appointmentletter'];
                        updateOnboardingStage(stageMap[activeStep]);
                    }} variant="contained" color="primary">
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default VerifiedDocument;
